import { ca } from '@cian/analytics';

export interface IParams {
  label: string;
}

/**
 * Отслеживает изменение настроек рассылок в Сообщениях
 */
export function trackMailingTogglesChange({ label }: IParams) {
  ca('eventSite', {
    action: 'Click',
    category: 'Messages',
    label,
    name: 'oldevent',
  });
}
